{
  "title": "LLM Configuration",
  "subtitle": "Providers, API keys, and default model",
  "catalog": {
    "title": "Model catalog",
    "model_col": "Model",
    "context_col": "Context",
    "tools_col": "Tools",
    "category_col": "Category",
    "size_col": "Size",
    "empty": "No models in this filter.",
    "free": "free",
    "set_for_agent": "Set model for agent"
  },
  "ollama": {
    "connection": "Ollama connection",
    "connected": "Connected",
    "offline": "Unavailable",
    "installed_models": "Installed models",
    "installed": "installed",
    "installed_count": "{{count}} installed",
    "search": "Search the official Ollama Library…",
    "refresh": "Refresh",
    "install": "Install",
    "remove": "Remove",
    "remove_confirm": "Really remove Ollama model “{{model}}”?",
    "use": "Use in agent",
    "no_models": "No Ollama models found.",
    "no_variants": "No variants available.",
    "pull_failed": "Installation failed",
    "library_offline": "The official Ollama Library is currently unavailable. Installed models remain accessible.",
    "fit_available": "Hardware detected",
    "fit_unavailable": "Hardware fit unavailable",
    "llmfit_not_installed": "llmfit is not installed",
    "llmfit_failed": "llmfit could not be executed",
    "llmfit_remote_ollama": "Ollama runs on another host; hardware fit for that host is not available yet",
    "context_capped": "Context window in use / the model's theoretical maximum. HydraHive caps the context based on free GPU memory so the model stays fully on the GPU.",
    "fit": {
      "perfect": "perfect",
      "good": "good",
      "marginal": "marginal",
      "too_tight": "too large",
      "unknown": "fit unknown"
    }
  },
  "providers": {
    "title": "Providers",
    "add": "Add provider",
    "none": "No provider configured yet",
    "no_key": "No key",
    "revoke_oauth": "Disconnect OAuth",
    "revoke_oauth_confirm": "Disconnect OAuth connection for \"{{provider}}\"?",
    "models_count": "{{count}} model",
    "models_count_plural": "{{count}} models"
  },
  "form": {
    "provider_label": "Provider",
    "api_key": "API Key",
    "models_label": "Models ({{selected}} selected)",
    "custom_model": "or enter custom model…",
    "or_oauth": "or via OAuth login",
    "oauth_connected": "Connected via OAuth"
  },
  "default_model": "Default model",
  "embed_model": "Embedding model",
  "embed_model_hint": "Vector dimension: {{dim}} — new events are embedded automatically",
  "default_models": {
    "title": "Default models",
    "chat": "Chat",
    "embed": "Embedding",
    "image": "Image",
    "music": "Music",
    "tts": "Speech (TTS)",
    "stt": "Transcription (STT)",
    "video": "Video",
    "local": "local",
    "free": "free",
    "paid": "paid",
    "cost_unknown": "cost unknown",
    "save_error": "Failed to save"
  },
  "media_models": {
    "title": "Media models",
    "hint": "Live from the model catalog, filtered by modality",
    "none": "No matching models — configure an OpenRouter key",
    "image": "Image",
    "music": "Music",
    "tts": "Speech (TTS)",
    "transcribe": "Transcription (STT)",
    "video": "Video"
  },
  "test": {
    "button": "Test connection",
    "saving": "Saving…",
    "ok": "OK · \"{{response}}\""
  },
  "usage": {
    "loading": "Loading rate limits…",
    "anthropic_title": "Anthropic OAuth Rate Limits",
    "window_5h": "5-Hour Window",
    "window_7d": "7-Day Window",
    "resets_at": "Resets",
    "threshold_warning": "Threshold exceeded",
    "threshold_explanation": "Usage has exceeded the threshold. Requests might be throttled."
  }
}